import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// ?view=editor mounts ONLY the detached PDF-editor window (lazy chunk, no login
// gate — it shares the opener's same-origin localStorage token). Everything
// else mounts the normal app.
const EditorWindow = lazy(() => import('./EditorWindow'));

const root = ReactDOM.createRoot(document.getElementById('root'));
const isEditorView = new URLSearchParams(window.location.search).get('view') === 'editor';

root.render(
  isEditorView ? (
    <Suspense fallback={null}>
      <EditorWindow />
    </Suspense>
  ) : (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
);
